import { Button, Tooltip } from '@mui/material'

type OTHourProps = {
  overTime: number
  overTimeNotes: string
}
export const OTHour = ({ overTime, overTimeNotes }: OTHourProps) => {
  return (
    <Tooltip
      title={<p className="whitespace-pre-line">{overTimeNotes?.trimStart()}</p>}
      style={{ whiteSpace: 'pre-line' }}
      placement="top"
    >
      {typeof overTime === 'number' ? (
        <Button
          variant="outlined"
          size="small"
          sx={{ color: 'primary.main' }}
          className="px-1 min-w-fit lowercase"
        >
          +{Number(overTime.toFixed(2))}h
        </Button>
      ) : (
        <></>
      )}
    </Tooltip>
  )
}
